import { createSlice } from '@reduxjs/toolkit';

const initialState = ['Magnet JQS Basic'];

const selServSlice = createSlice({
    name: "services",
    initialState,
    reducers: {
        serviceAdded(state, action) {         
            state.push(action.payload);
        }, 
        serviceRemoved(state, action) {
            return state.filter((service) => service !== action.payload);
        },
        servicesReplaced(state, action) {
            return state = action.payload;
        }
    }
});

export const servicesSelector = (state) => state.selectedServices;

export const { serviceAdded, serviceRemoved, servicesReplaced} = selServSlice.actions;
export default selServSlice.reducer;
